import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateAttributeFilter } from 'app/shared/ui/models/date-attribute-filter';

@Component({
  selector: 'jhi-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
})
export class DateFilterComponent {
  @Input() filter!: DateAttributeFilter;
  @Output() filterChange = new EventEmitter<DateAttributeFilter>();
}
